import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "frame"]

  connect() {
    this.keydownHandler = (e) => {
      if (e.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) {
        this.close()
      }
    }
    document.addEventListener("keydown", this.keydownHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.keydownHandler)
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    event?.preventDefault()
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.frameTarget.innerHTML = ""
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
